import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import DatePicker from "react-datepicker"
import MUIDataTable from "mui-datatables";
import Selectsearch from "react-select"


// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import  'Routes/common/common.css';


import {
   allTravelReport,
   allSSTeam,
   allStudents, 
} from 'Actions';


import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


class travelreport extends Component {
   
   constructor(props) {
      
      super(props);
       
        this.state = {
            student: '',
            checkoutdate:'',
            checkindate:'',
            seldate:new Date(),
        };     
               
        this.handleSubmit = this.handleSubmit.bind(this)
   }

   UNSAFE_componentWillMount() {
		this.props.allStudents();  
       this.getreport();
	}

    getreport(){
        var startdate=this.state.checkoutdate;
        var enddate=this.state.checkindate;
        var student=this.state.student;
        this.props.allTravelReport(startdate,enddate,student);
    }

    handleSubmit(event)
    {
        event.preventDefault();
        this.getreport()
    }

   

    selectdates = (date) => {
  
      this.setState({ checkoutdate:date });    
     
    }
  
    selectdatee = (date) => {
           
       this.setState({ checkindate:date });      
      
    }

  
   
    render() {

       const { match, studentlists,travelreportlist,loading,} = this.props;
       
       
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };
       
        const allstudent=studentlists.map((stdval) => {  
            
              return {
                label: stdval.student,  
                value: stdval.uudID
            
              }
              
        });
    
        const columns = [
            { name: "sno", label: " SNO" },
            { name: "sname", label: "STUDENT NAME" },
            { name: "checkoutdate", label: "CHECK-OUT DATE" },
            { name: "checkouttime", label: "CHECK-OUT TIME" },
            { name: "checkindate", label: "CHECK-IN DATE" },
            { name: "checkintime", label: "CHECK-IN TIME" },
            { name: "totaldays", label: "TOTAL DAYS" },

        ];
        const tabledata=travelreportlist.map((assmntval,idx) => {   




            if(assmntval.cttf_acdycheckoutdate=='0000-00-00'){
                var checkoutday=assmntval.choutdate;
                var checkouttime=assmntval.cttf_checkouttime;                                        
            }else{
                var checkoutday=assmntval.acdychoutdate;  
                var checkouttime=assmntval.cttf_acdycheckouttime;   
            }
            if(assmntval.cttf_acdycheckindate=='0000-00-00'){
                var checkinday=assmntval.chindate;  
                var checkintime=assmntval.cttf_checkintime;
            }else{
                var checkinday=assmntval.acdychindate;  
                var checkintime=assmntval.cttf_acdycheckintime;  
            }

            if(assmntval.cttf_acdyenterby==''){  
                var totdays=assmntval.cttf_totaldays;
            }else{
                var totdays=assmntval.cttf_acdyuptdays;
            }


                   
                return ( {
                sno:idx+1,
                sname: assmntval.student,
                checkoutdate: checkoutday,
                checkouttime: checkouttime,
                checkindate: checkinday,
                checkintime: checkintime,
                totaldays:totdays,
                })
        });

        
   

       return (

        
         
       <div className="saas-dashboard">
         
             <Helmet>
                <title>Travel Report | {AppConfig.appTitle}</title>
                <meta name="description" content="Travel" />
             </Helmet>
             
             <PageTitleBar title={<IntlMessages id="sidebar.travelreport" />} match={match} />
              <div className="col-lg-12">
             
                  <RctCollapsibleCard heading="Student Travel Report" fullBlock>
                        <form autoComplete="off" id="addform">                   
                            <div className="row" style={{padding:"20px"}}>
                                <div className="col-lg-3">
                                        <FormGroup >
                                            <Label for="Email-3">Start Date </Label>
                                            <DatePicker className="form-control" id="checkoutdate"  name="checkoutdate" autoComplete="off" 
                                                    selected={this.state.checkoutdate}
                                                    onChange={this.selectdates}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown 
                                                    
                                                /> 
                                        </FormGroup>                                          
                                </div>

                                    <div className="col-lg-3">
                                        <FormGroup >
                                            <Label for="Email-3">End Date </Label>
                                            <DatePicker className="form-control" id="checkindate"  name="checkindate" autoComplete="off" 
                                                    selected={this.state.checkindate}
                                                    onChange={this.selectdatee}
                                                    dateFormat='yyyy-MM-dd'
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                /> 
                                        </FormGroup>                                          
                                    </div> 

                                    <div className="col-lg-3">                                           
                                        <Label for="Email-3">Student </Label>
                                        <Selectsearch id="student" name="student" options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.setState({ student: evt.value })} required/>                                            
                                    </div> 

                                    <div className="form-group">                       
                                            <input type="submit" onClick={this.handleSubmit} className="mr-3 mb-3 btn btn-outline-primary" value="Submit" style={{marginTop:"20px"}}/>                                            
                                    </div>  
                                                         
                            </div>
                        </form>    
                            
                   </RctCollapsibleCard>
                </div>   

                <div className="col-lg-12">
                    <RctCollapsibleCard heading="Report" fullBlock>
                        <MUIDataTable    
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        /> 
                    </RctCollapsibleCard>      
                     
                </div>  
                
         </div>
       )

      }
 }

const mapStateToProps = ({travelreport,mostlyused, ssteam}) => {
    const { studentlists, } = mostlyused;
    
	const { travelreportlist, loading } = travelreport;
	return { studentlists,travelreportlist,loading };



}



// const mapStateToProps = ({ mostlyused, ssteam }) => {
//     const { studentlists, loading } = mostlyused;
//     const { ssteamlists } = ssteam;
//     return { studentlists, ssteamlists, loading };
   
// }

export default connect(mapStateToProps,{
    allTravelReport,
    allSSTeam,
    allStudents,
  
})(travelreport); 